// extracted by mini-css-extract-plugin
export default {"container":"styles_container__p2zjv","header":"styles_header__A14WW"};